import React, { useEffect, useState } from "react";
import "./settings.scss";

import HeaderSettings from "./components/headerSettings/HeaderSettings";
import ContainerSettings from "./components/containerSettings/ContainerSettings";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import { Stack } from "react-bootstrap";

import { getUserInfo } from "./api/settingsApi";

import { settingsMenu } from "./data/settingsMenu";
import HeaderBar from "../../components/headerBar/HeaderBar";
import { t } from "i18next";

const Settings = () => {
  const [userData, setUserData] = useState({});

  useEffect(() => {
    getUserInfo()
      .then((res) => {
        setUserData(res);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <div className="container-settings">
      <HeaderBar title={t("settings.title")} option={false} back={true} />
      <div className="d-flex justify-content-center">
        <div className="content-settings">
          {userData ? (
            <HeaderSettings
              name={userData.name}
              surname={userData.surname}
              image_profile={userData.image_profile}
              image_type={userData.image_type}
            />
          ) : null}
          <Stack gap={3}>
            {settingsMenu
              ? settingsMenu.map((item, index) => {
                  return <ContainerSettings key={index} list={item} />;
                })
              : null}
          </Stack>
          <VoidSpace height={85} />
        </div>
      </div>
    </div>
  );
};

export default Settings;
